import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getOrderSettingsSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/OrderSettingsRule/hooks/getOrderSettingsSubheader';

export interface UseOrderSettingsSubheader {
  subheader: string;
}

export const useOrderSettingsSubheader = (): UseOrderSettingsSubheader => {
  const { watch } = useFormContext<IMealCreditFormFields>();
  const fulfillmentTypes = watch('fulfillmentType');
  const availableOrderTypes = watch('availableOrderTypes');
  const subheader = getOrderSettingsSubheader({
    fulfillmentTypes,
    availableOrderTypes,
  });

  return {
    subheader,
  };
};
